module.exports = __webpack_public_path__ + "img/background.f2224db4.jpg";